module.exports = __webpack_public_path__ + "img/ic_contentitem_add.cdbaf672.svg";